const beingTogetherSlider = () => {
    const container = document.querySelector('.being-together');
    
    if (!container) {
        return;
    }

    const slider = container.querySelector('.being-together-slider');
    if (!slider) {
        return;
    }

    let isSliding = false;
    const DISPLAY_DURATION = 3000; // 3 seconds display
    const ANIMATION_DURATION = 800; // 0.8 seconds animation (matching CSS transition)

    // Clone first item and append to end for smooth infinite loop
    const initClone = () => {
        const firstItem = slider.querySelector('.item:first-child');
        if (firstItem) {
            const clone = firstItem.cloneNode(true);
            slider.appendChild(clone);
        }
    };

    const slide = () => {
        if (isSliding) {
            return;
        }

        isSliding = true;

        // Start sliding animation
        container.classList.add('sliding');

        // Wait for animation to complete
        setTimeout(() => {
            // Disable transition temporarily
            slider.style.transition = 'none';
            
            // Remove the first item
            const firstItem = slider.querySelector('.item:first-child');
            slider.removeChild(firstItem);
            
            // Reset transform
            container.classList.remove('sliding');
            
            // Force reflow to apply the reset
            void slider.offsetHeight;
            
            // Re-enable transition
            slider.style.transition = '';
            
            // Clone the new first item and append to end
            const newFirstItem = slider.querySelector('.item:first-child');
            if (newFirstItem) {
                const clone = newFirstItem.cloneNode(true);
                slider.appendChild(clone);
            }

            isSliding = false;
        }, ANIMATION_DURATION);
    };

    // Initialize: clone first item
    initClone();

    // Start the animation loop
    const startAnimation = () => {
        // First slide after 3 seconds
        setTimeout(() => {
            slide();
            
            // Then continue sliding every 3 seconds + animation duration
            setInterval(() => {
                slide();
            }, DISPLAY_DURATION + ANIMATION_DURATION);
        }, DISPLAY_DURATION);
    };

    // Initialize
    startAnimation();
};

module.exports = beingTogetherSlider;

